var map = {
	"./CS-logo.jpg": 5994,
	"./DOTNET-logo.png": 9645,
	"./angular-logo.png": 7781,
	"./arag.jpg": 464,
	"./cnn.png": 2351,
	"./dungeoncrawler-logo.jpeg": 9678,
	"./github.png": 4343,
	"./gmail.png": 8578,
	"./intro-photo.jpg": 144,
	"./java-logo.png": 2906,
	"./js-logo.png": 5045,
	"./linkedin.png": 8518,
	"./node-logo.png": 2035,
	"./police.png": 4262,
	"./profile.jpg": 158,
	"./python-logo.png": 1868,
	"./sql-logo.png": 6019,
	"./vue-logo.png": 5519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;